import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Auth from './Auth';

import AuthCallback from '../pages/AuthCallback';
import AdminPanel from '../pages/AdminPanel';
import DishList from '../pages/DishList';
import Orders from './Orders'; // ✅ используем его везде
import Dashboard from './Dashboard';
import Statistics from './Statistics';
import Supplier from './Supplier';
import UserPanel from './UserPanel';
import CustomerPanel from './CustomerPanel';
import MyOrder from '../pages/MyOrder';
import OrdersHistory from '../pages/OrdersHistory';
import Billing from './Billing'; // ✅ новый компонент
import AdminSupplier from './AdminSupplier';
import SupplierStats from './SupplierStats';

// ❌ Удаляем:
// import AdminOrders from '../pages/AdminOrders';

import { useUser } from '../context/UserContext';

// Защищённые маршруты
const ProtectedRoute = ({ element }) => {
    const { isAuthenticated, loading, isTelegramApp } = useUser();

    if (loading) return <div className="flex justify-center items-center text-white p-8">Загрузка...</div>;
    return (isAuthenticated || isTelegramApp) ? element : <Navigate to="/auth" replace />;
};

const AdminRoute = ({ element }) => {
    const { user, isAuthenticated, loading, isTelegramApp } = useUser();

    if (loading) return <div className="flex justify-center items-center text-white p-8">Проверка прав...</div>;
    return (isAuthenticated || isTelegramApp) && user?.role === 'admin' ? element : <Navigate to="/auth" replace />;
};

const UserRoute = ({ element }) => {
    const { user, isAuthenticated, loading, isTelegramApp } = useUser();

    if (loading) return <div className="flex justify-center items-center text-white p-8">Проверка прав...</div>;
    return (isAuthenticated || isTelegramApp) && user?.role === 'user' ? element : <Navigate to="/auth" replace />;
};

const CustomerRoute = ({ element }) => {
    const { user, isAuthenticated, loading, isTelegramApp } = useUser();

    if (loading) return <div className="flex justify-center items-center text-white p-8">Проверка прав...</div>;
    return (isAuthenticated || isTelegramApp) && user?.role === 'customer' ? element : <Navigate to="/auth" replace />;
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
            <Route path="/admin" element={<AdminRoute element={<AdminPanel />} />} />
            <Route path="/admin/orders" element={<AdminRoute element={<Orders />} />} /> {/* ✅ заменили */}
            <Route path="/user" element={<UserRoute element={<UserPanel />} />} />
            <Route path="/supplier" element={<CustomerRoute element={<CustomerPanel />} />} />
            <Route path="/dishes" element={<ProtectedRoute element={<DishList />} />} />
            <Route path="/orders" element={<ProtectedRoute element={<Orders />} />} />
            <Route path="/statistics" element={<ProtectedRoute element={<Statistics />} />} />
            <Route path="/billing" element={<ProtectedRoute element={<Billing />} />} /> {/* ✅ новый маршрут */}
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/my-order" element={<ProtectedRoute element={<MyOrder />} />} />
            <Route path="/orders-history" element={<ProtectedRoute element={<OrdersHistory />} />} />
            <Route path="/admin/supplier" element={<AdminRoute element={<AdminSupplier />} />} />
            <Route path="/supplier-stats" element={<ProtectedRoute element={<SupplierStats />} />} />

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
